import { RECEIVE_PRODUCT_DATA } from '../actions';

export default (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_PRODUCT_DATA:
      return action.product;
    default:
      return { ...state };
  }
};
